import React from 'react';
import { BookOpen, ShoppingBag } from 'lucide-react';
import { featuredBook } from '../mock';

const FeaturedBook = () => {
  return (
    <section id="book" className="py-28 bg-[#faf7f0] relative overflow-hidden">
      <div className="absolute right-0 top-0 w-1/3 h-full bg-gradient-to-l from-[#f1ead8] to-transparent pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center relative">
        <div className="lg:col-span-5">
          <div className="relative max-w-sm mx-auto">
            <div className="absolute -inset-6 border border-[#c9a961]/40" />
            <div className="absolute -inset-12 border border-[#c9a961]/15" />
            <div
              className="aspect-[3/4] bg-cover bg-center shadow-2xl"
              style={{ backgroundImage: `url(${featuredBook.cover})` }}
            />
            <div className="absolute -bottom-5 -right-5 bg-[#1a1714] text-[#e8d9a8] px-5 py-3 font-display">
              <div className="text-[10px] tracking-[0.3em] uppercase text-[#c9a961]">Bestseller</div>
              <div className="text-lg">Top 10 · Soul Reads</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="ornament mb-4">
            <span className="section-eyebrow">The Featured Work</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#1a1714] leading-tight">
            {featuredBook.title}
          </h2>
          <p className="font-cormorant italic text-xl md:text-2xl gold-text mt-3">
            {featuredBook.subtitle}
          </p>

          <ul className="mt-8 space-y-3.5">
            {featuredBook.bullets.map((b) => (
              <li key={b} className="flex items-start gap-3 text-[15px] text-[#4a4035] leading-relaxed">
                <BookOpen size={16} className="text-[#a8842c] shrink-0 mt-1" />
                <span>{b}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-wrap gap-4">
            <a href="#contact" className="btn-gold">
              <ShoppingBag size={14} /> Order Your Copy
            </a>
            <a href="#contact" className="btn-outline-gold">Read a Sample Chapter</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedBook;
